import { getUrlParams } from '../utils/helpers/common'
import { getMobileOperatingSystem } from '../utils/helpers/deviceType'
import { EVENTS, GTM_EVENT_CONFIG } from './events'
import googleAnalyticsUtils from './google-analytics-utils'
import gtmUtils from './gtm-utils'
import moEngageUtils from './mo-engage-utils'
import webEngageUtils from './web-engage-utils'

export const initAnalytics = () => {
  // Initialize WebEngage
  // webEngageUtils.initializeWebEngage()
  // Initialize GA4
  googleAnalyticsUtils.initializeGA4()
  // Initialize GTM
  gtmUtils.initializeGTM()

  // Initialize MoEngage
  moEngageUtils.initializeWebEngage()
}

const trackWebEngageEvent = (eventName, eventData) => {
  webEngageUtils.trackEvent(eventName, {
    appName: process.env.REACT_APP_FE_URL,
    ...eventData,
  })
}

/**
 * Resolves event config for GTM/GA4. Returns snake_case event name and structured metadata.
 */
const resolveEventConfig = (eventName) => {
  const config = GTM_EVENT_CONFIG[eventName]
  if (config) {
    return {
      gtmEventName: config.event,
      page_type: config.page_type,
      section: config.section,
      user_action: config.user_action,
    }
  }
  return {
    gtmEventName:
      typeof eventName === 'string'
        ? eventName.toLowerCase()
        : String(eventName),
    page_type: undefined,
    section: undefined,
    user_action: undefined,
  }
}

const trackGA4Event = (eventName, eventData) => {
  if (eventName === EVENTS.PAGE_VIEW && window?.location?.pathname) {
    googleAnalyticsUtils.trackPageview(
      window?.location?.pathname,
      eventData?.screenName,
    )
  } else {
    const config = resolveEventConfig(eventName)
    const ga4Payload = {
      ...eventData,
      ...(config.page_type != null && { page_type: config.page_type }),
      ...(config.section != null && { section: config.section }),
      ...(config.user_action != null && { user_action: config.user_action }),
    }
    googleAnalyticsUtils.trackEvent(config.gtmEventName, ga4Payload)
  }
}

const trackGTMEvent = (eventName, eventData) => {
  if (eventName === EVENTS.PAGE_VIEW && window?.location?.pathname) {
    gtmUtils.trackPageview(window?.location?.pathname, eventData?.screenName)
  } else {
    const config = resolveEventConfig(eventName)
    gtmUtils.trackEvent({
      event: config.gtmEventName,
      page_type: config.page_type,
      section: config.section,
      user_action: config.user_action,
      attributes: eventData,
    })
  }
}

const trackMoEngageEvent = (eventName, eventData) => {
  const { gtmEventName } = resolveEventConfig(eventName)
  moEngageUtils.trackEvent(gtmEventName, eventData)
}

export const trackEvent = (eventName = '', eventData = {}) => {
  try {
    trackWebEngageEvent(eventName, eventData)
    trackGA4Event(eventName, eventData)
    trackMoEngageEvent(eventName, eventData)
  } catch (error) {
    console.error('Error tracking event:', error)
  }
}

export const trackEventCKD = (eventName = '', eventExtraData = {}) => {
  // UTM parameters from URL or local storage
  const storedParams = JSON.parse(localStorage.getItem('query_params') || '{}')
  const urlParamss = getUrlParams()

  const paramsToCapture = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ]

  const params = paramsToCapture.reduce((acc, param) => {
    acc[param] = urlParamss[param] || storedParams[param] || undefined
    return acc
  }, {})

  if (Object.keys(params).length > 0) {
    localStorage.setItem('query_params', JSON.stringify(params))
  }

  const eventData = {
    ...params,
    Mobile: getMobileOperatingSystem(),
    ...eventExtraData,
  }

  console.log('trackEventCKD - eventData -->', eventData)

  const safeTrack = (label, fn) => {
    try {
      fn()
    } catch (error) {
      console.error(`Error tracking ${label}:`, error)
    }
  }

  safeTrack('MoEngage event', () => trackMoEngageEvent(eventName, eventData))
  if (process.env.REACT_APP_ENV === 'production') {
    safeTrack('GA4 event', () => trackGA4Event(eventName, eventData))
    safeTrack('GTM event', () => trackGTMEvent(eventName, eventData))
  }
}

export const analytics = {
  setUserProperties: (user) => {
    moEngageUtils.setUserAttributes(user)
    googleAnalyticsUtils.setUserAttributes(user)
    gtmUtils.setUserAttributes(user)
  },
  logout: () => {
    moEngageUtils.logout()
  },
}
